/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react';
import CategoryBtn from './CategoryBtn';
import FilterItem from './FilterItem';
import projectFilterData from './projectFilterData';

// Unique categories derived from the data, in consistent order
const categories = [...new Set(projectFilterData.map((d) => d.category))].sort();

// "muara-enim" → "Muara Enim"
function formatLabel(cat) {
    return cat.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

function ProjectFilter() {
    const [category, setCategory] = useState('all');
    const [filteredItem, setFilteredItem] = useState([]);

    useEffect(() => {
        category === 'all'
            ? setFilteredItem(projectFilterData)
            : setFilteredItem(projectFilterData.filter((data) => data.category === category));
    }, [category]);

    return (
        <section className="portfolio-wrapper-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-12 text-center">
                        <div className="section-title-2">
                            <span>Gallery</span>
                            <p>Offices and Warehouses</p>
                            <h1>Our Gallery</h1>
                        </div>
                    </div>
                </div>

                <div className="row mb-20">
                    <div className="col-12 col-lg-12 text-center">
                        <div className="portfolio-cat-filter">
                            <CategoryBtn
                                className={category === 'all' ? 'btn-active' : null}
                                name="all"
                                label="View All"
                                handleSetCategory={setCategory}
                            />
                            {categories.map((cat) => (
                                <CategoryBtn
                                    key={cat}
                                    className={category === cat ? 'btn-active' : null}
                                    name={cat}
                                    label={formatLabel(cat)}
                                    handleSetCategory={setCategory}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                <div className="row grid">
                    {filteredItem.map(
                        (item, length) =>
                            length <= '15' && (
                                <FilterItem
                                    key={item.id}
                                    image={item.image}
                                    category={item.category}
                                />
                            )
                    )}
                </div>
            </div>
        </section>
    );
}

export default ProjectFilter;
